/**
 * DATEV-Settings enumerations.
 *
 * Naming policy reminder (see CLAUDE.md → "Naming convention"): the DATEV/tax
 * terms of art (`Gewinnermittlungsart`, `Versteuerungsart`, `Kontenrahmen`) and
 * their values (`EUR`/`BILANZ`, `SOLL`/`IST`/`NICHT_RELEVANT`, `SKR03`/`SKR04`)
 * map 1:1 to the DATEV EXTF spec and German tax law and stay German on
 * purpose. General concepts around them use English.
 */
/**
 * Profit-determination method (§4 EStG).
 *
 * Drives whether the DATEV export is payment-triggered (`EUR` →
 * Einnahmen-Überschuss-Rechnung, payment receipts) or invoice-triggered
 * (`BILANZ` → balance-sheet accounting, issued invoices).
 *
 * This is the **export driver** — it decides which invoices appear in a given
 * export run, not how taxable revenue is mapped to BU-Schlüssel. The two
 * concepts are independent.
 */
export var Gewinnermittlungsart;
(function (Gewinnermittlungsart) {
    Gewinnermittlungsart["EUR"] = "EUR";
    Gewinnermittlungsart["BILANZ"] = "BILANZ";
})(Gewinnermittlungsart || (Gewinnermittlungsart = {}));
/**
 * VAT-timing scheme (§16/§20 UStG).
 *
 * Feeds the Konten-Mapping / BU-Schlüssel for *taxable* revenue rows only
 * (19 % / 7 %). The dominant physiotherapy case is `NICHT_RELEVANT`
 * (§4 Nr. 14a UStG steuerfreie Heilbehandlung), for which versteuerungsart
 * has no effect at all.
 *
 * Crucially: **does not select export candidates.** Flipping SOLL↔IST must
 * never change which invoices end up in an export.
 */
export var Versteuerungsart;
(function (Versteuerungsart) {
    Versteuerungsart["SOLL"] = "SOLL";
    Versteuerungsart["IST"] = "IST";
    Versteuerungsart["NICHT_RELEVANT"] = "NICHT_RELEVANT";
})(Versteuerungsart || (Versteuerungsart = {}));
/**
 * DATEV's standard chart of accounts.
 *
 * SKR03 (process-oriented) is the historical default for service businesses;
 * SKR04 (HGB-aligned) is increasingly chosen by newer practices.
 */
export var Kontenrahmen;
(function (Kontenrahmen) {
    Kontenrahmen["SKR03"] = "SKR03";
    Kontenrahmen["SKR04"] = "SKR04";
})(Kontenrahmen || (Kontenrahmen = {}));
//# sourceMappingURL=datev-enums.js.map